import { coreClipAPIs } from "../core/clipDetailsAPIs";
import { newsAPIs } from "../core/newsAPIs";
import { appSettingsAPIs } from "./appSettingsAPIs";
import { audioAPIs } from "./audioAPIs";
import { bumperAPIs } from "./bumperAPIs";
import { categoryAPIs } from "./categoryAPIs";
import { categoryConfigurationAPIs } from "./categoryConfigurationAPIs";
import { centraliseStorageAPIs } from "./centraliseStorageAPIs";
import { channelSummaryAPIs } from "./channelSummaryAPIs";
import { clientAPIs } from "./clientAPIs";
import { clipAPIs } from "./clipAPIs";
import { clipListAPIs } from "./clipListAPIs";
import { clipVideosAPIs } from "./clipVideosAPIs";
import { commonAPIs } from "./commonAPIs";
import { countryAPIs } from "./countryAPIs";
import { datafeedAPIs } from "./datafeedAPIs";
import { entityConfigAPIs } from "./entityConfigAPIs";
import { featureListAPIs } from "./featureListAPIs";
import { fieldsAPIs } from "./fieldsAPIs";
import { flpListAPIs } from "./ftpListAPIs";
import { graphicAPIs } from "./graphicAPIs";
import { illustoAccountAPIs } from "./illustoAccountAPIs";
import { illustoProxy } from "./illustoProxy.js";
import { ingestionAPIs } from "./ingestionAPIs";
import { keyManagementAPIs } from "./keyManagementAPIs";
import { matchScheduleAPIs } from "./matchScheduleAPIs";
import { mediaLiveOutputTemplateAPIs } from "./mediaLiveOutputTemplateAPIs";
import { metaDataAPIs } from "./metaDataAPIs";
import { onedriveAPIs } from "./onedriveAPIs";
import { organizationAPIs } from "./organizationAPIs";
import { organizationMemberAPIs } from "./organizationMemberAPIs";
import { packageAPIs } from "./packageAPIs";
import { planAPIs } from "./planApis";
import { reservedChannelAPIs } from "./reservedChannelAPIs";
import { roleAPIs } from "./roleAPIs";
import { ruleConfigurationAPIs } from "./ruleConfigurationAPIs";
import { ruleConfigurationV2APIs } from "./ruleConfigurationV2APIs";
import { ruleExecutionAPIs } from "./ruleExecutionAPIs";
import { serverAPIs } from "./serverAPIs";
import { settingsAPIs } from "./settingsAPIs";
import { showAPIs } from "./showAPIS";
import { srtSecretAPIs } from "./srtSecretAPis";
import { storageAPIs } from "./storageAPIs";
import { streamAPIs } from "./streamAPIs";
import { streamPointerAPIs } from "./streamPointerAPIs";
import { streamTemplateAPIs } from "./streamTemplateAPIs";
import { tagsAPIs } from "./tagsAPIs";
import { teamAPIs } from "./teamAPIs";
import { templateAPIs } from "./templateAPIs";
import { templateConfigAPIs } from "./templateConfigAPIs";
import { tournamentsAPIs } from "./tournamentsAPIs";
import { userAPIs } from "./userAPIs";
import { v2StreamAPIs } from "./v2/streamAPIs";
import { videoConversionTemplateAPIs } from "./videoConversionTemplateAPIs";
import { webStoryAPIs } from "./webStoryAPIs";
import { webStoryTemplateAPIs } from "./webStoryTemplateAPIs";
import { workspaceAPIs } from "./workspaceAPIs";
import { xmlFormatsAPIs } from "./xmlFormatsAPIs";
const magnifiAPI = {
  ...featureListAPIs,
  ...appSettingsAPIs,
  ...datafeedAPIs,
  ...roleAPIs,
  ...userAPIs,
  ...entityConfigAPIs,
  ...streamAPIs,
  ...v2StreamAPIs,
  ...clipListAPIs,
  ...audioAPIs,
  ...clipAPIs,
  ...tournamentsAPIs,
  ...storageAPIs,
  ...commonAPIs,
  ...ruleConfigurationAPIs,
  ...ruleExecutionAPIs,
  ...bumperAPIs,
  ...graphicAPIs,
  ...illustoProxy,
  ...teamAPIs,
  ...settingsAPIs,
  ...flpListAPIs,
  ...categoryAPIs,
  ...organizationAPIs,
  ...tagsAPIs,
  ...keyManagementAPIs,
  ...xmlFormatsAPIs,
  ...srtSecretAPIs,
  ...metaDataAPIs,
  ...templateAPIs,
  ...reservedChannelAPIs,
  ...webStoryTemplateAPIs,
  ...serverAPIs,
  ...clientAPIs,
  ...centraliseStorageAPIs,
  ...streamTemplateAPIs,
  ...templateConfigAPIs,
  ...packageAPIs,
  ...categoryConfigurationAPIs,
  ...channelSummaryAPIs,
  ...mediaLiveOutputTemplateAPIs,
  ...workspaceAPIs,
  ...showAPIs,
  ...organizationMemberAPIs,
  ...clipVideosAPIs,
  ...videoConversionTemplateAPIs,
  ...streamPointerAPIs,
  ...onedriveAPIs,
  ...matchScheduleAPIs,
  ...webStoryAPIs,
  ...planAPIs,
  ...illustoAccountAPIs,
  ...ruleConfigurationV2APIs,
  ...coreClipAPIs,
  ...countryAPIs,
  ...newsAPIs,
  ...fieldsAPIs,
  ...ingestionAPIs,
};
export default magnifiAPI;
